import { css, FlattenInterpolation, FlattenSimpleInterpolation, ThemeProps } from 'styled-components';
import { breakpoints, ModifiersBreakpoints } from '@styles/vars';

export const respondTo = Object.keys(breakpoints).reduce(
    (accumulator: any, label: keyof typeof breakpoints) => {
        accumulator[label] = (args: FlattenInterpolation<ThemeProps<any>>) => css`
            @media (min-width: ${breakpoints[label]}) {
                ${args};
            }
        `
        return accumulator
    }, {}
)

export const tablet = respondTo.tablet
export const mTablet = respondTo["tablet-m"]
export const desktop = respondTo.desktop

export const modifier = (modifier: string, styles: FlattenInterpolation<ThemeProps<any>>) => {
    return (props: any) => {
        let isModifierExists
        const nested = modifier.split(":")

        if (nested.length === 1) {
            isModifierExists = props[modifier]
        } else {
            if (typeof nested[1] === "boolean") isModifierExists = nested[1]
            else isModifierExists = props[nested[0]] === nested[1]
        }

        if (isModifierExists) return styles
    }
}

export const placeholder = (styles: any) => {
    return () => {
        return css`
            &::-webkit-input-placeholder {${styles}}
            &:-moz-placeholder           {${styles}}
            &::-moz-placeholder          {${styles}}
            &:-ms-input-placeholder      {${styles}}
        `
    }
}

export const autofill = (styles: any) => {
    return css`
        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus {
            ${styles}
        }
    `
}

export const respondModifiersToBreakpoints = (
    object: ModifiersBreakpoints<any, any>, 
    name: string, 
    style: (value: string) => FlattenSimpleInterpolation
) => {
    const modifiers: any[] = []

    for (const key in object) {
        if (!object.hasOwnProperty(key))
            continue

        const type = object[key]
        for (const breakpoint in type) {
            if (!object[key].hasOwnProperty(breakpoint))
                continue
            
            const value = type[breakpoint as keyof typeof type]
            if (breakpoint === "default") {
                modifiers.push(modifier(`${name}:${key}`, style(value)))
            } else {
                modifiers.push(modifier(`${name}:${key}`, css`
                    ${respondTo[breakpoint](style(value))}
                `))
            }
            
        }
    }

    return modifiers
}

const breakpointsModifiers = {
    0: (css: FlattenSimpleInterpolation) => css,
    1: (css: FlattenSimpleInterpolation) => tablet(css),
    2: (css: FlattenSimpleInterpolation) => desktop(css),
}

/**
 * Applies a given rule to a breakpoints.
 * Breakpoints are given as a string which values are separated by `|`.
 * First value corresponds to a phone.
 * Second value corresponds to a tablet.
 * Third value corresponds to a desktop.
 */
export const applyRuleToBreakpoints = (
    rawValues: string, 
    rule: (value: string) => FlattenSimpleInterpolation
): FlattenSimpleInterpolation[] => {
    const result = []
    const values = rawValues.split("|")
    let i = 0
    for (const value of values) {
        if (i > 2) continue
        const modify = breakpointsModifiers[i as 0 | 1 | 2]
        result.push(modify(rule(value)))
        i++
    }

    return result
}